// eslint-disable-next-line import/prefer-default-export
export const aiEvents = {
  paymentProviders: {
    totalProcessing: {
      event: "TotalProcessingEvent",
      error: "TotalProcessingError",
    },
  },
  payments: {
    intentToPay: {
      registerRequest: "IntentToPayRegisterRequest",
      registerResult: "IntentToPayRegisterResult",
      update: "IntentToPayUpdate",
      cancel: "IntentToPayCancel",
      completeRequest: "IntentToPayCompleteRequest",
      completeResult: "IntentToPayCompleteResult",
    },
    paymentButtonClicked: "PaymentButtonClicked",
    paymentMethodSelectionClicked: "PaymentMethodSelectionClicked",
    processing: {
      checkStatusError: "PaymentProcessingCheckStatusError",
    },
    surcharge: {
      // The quote call failed: the payer pays without a fee
      quoteFailed: "SurchargeQuoteFailed",
      // The start-pay call failed: the card is charged with the shown total
      startPayFailed: "SurchargeStartPayFailed",
      // The card BIN couldn't be read: the payer pays without a fee
      cardBinUnavailable: "SurchargeCardBinUnavailable",
    },
  },
};

export const aiActions = {
  paymentProviders: {
    totalProcessing: {
      redirectQueryInvalid: "RedirectQueryInvalid",
    },
  },
};

export const aiMetrics = {
  payments: {
    processing: {
      paymentStatusCalls: "PaymentStatusCalls",
      paymentWaitingRedirect: "PaymentWaitingRedirect",
    },
  },
};
